module.exports = __webpack_public_path__ + "img/home-03.fa873297.svg";